import { createContext } from 'react';

import { Services } from '../../types';

export default createContext<Services.DataServiceContext>(
  {} as Services.DataServiceContext,
);
